const NOTIFICATION_PARAMS = {
  bookings: {
    approve: {
      label: "New Role for Approval",
      permission: "new-booking-for-approval"
    },
    approved: {
      label: "Role Approved",
      permission: "booking-approved"
    },
    accept: {
      label: "Accept Role",
      permission: "accept-booking"
    },
    rejected: {
      label: "Role Rejected",
      permission: "booking-rejected"
    },
    accepted: {
      label: "Role Accepted",
      permission: "booking-accepted"
    },
    cancelled: {
      label: "Role Cancelled",
      permission: "booking-cancelled"
    },
    published: {
      label: "New Role",
      permission: "new-booking"
    },
    matched: {
      label: "Matched with Role",
      permission: "booking-matched"
    }
  },
  interviews: {
    schedule: {
      label: "Schedule Interview",
      permission: "schedule-interview"
    },
    "submit-feedback": {
      label: "Submit Interview Feedback",
      permission: "submit-interview-feedback"
    },
    confirm: {
      label: "Confirm Interview",
      permission: "confirm-interview"
    },
    reschedule: {
      label: "Reschedule Interview",
      permission: "reschedule-interview"
    },
    invited: {
      label: "Interview Invite",
      permission: "interview-invite"
    },
    rescheduled: {
      label: "Interview Rescheduled",
      permission: "interview-rescheduled"
    },
    cancelled: {
      label: "Interview Cancelled",
      permission: "interview-cancelled"
    },
    "interviewer-declined": {
      label: "Interviewer Declined Interview",
      permission: "interviewer-declined-interview"
    }
  },
  offers: {
    "submit-references": {
      label: "Submit References for Offer",
      permission: "submit-references-for-offer"
    },
    "submit-additional-references": {
      label: "Submit Additional References",
      permission: "submit-additional-references"
    },
    "approve-offer": {
      label: "Approve Offer",
      permission: "approve-offer"
    }
  },
  applications: {
    received: {
      label: "New Application",
      permission: "new-application"
    },
    shortlisted: {
      label: "Application Shortlisted",
      permission: "application-shortlisted"
    },
    interview: {
      label: "Interview Requested",
      permission: "interview-requested"
    },
    approved: {
      label: "Application Approved",
      permission: "application-approved"
    },
    rejected: {
      label: "Application Rejected",
      permission: "application-rejected"
    },
    withdrawn: {
      label: "Application Withdrawn",
      permission: "application-withdrawn"
    }
  },
  comments: {
    created: {
      label: "New Comment",
      permission: "new-comment"
    }
  }
};

const getNotificationParams = (type, baseName) => {
  return NOTIFICATION_PARAMS[type] ? NOTIFICATION_PARAMS[type][baseName] : {};
};

export default getNotificationParams;
